import { ExamsService } from "./exams.service";

import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { SnackBarService } from "app/services/snackbar.service";
import { DomSanitizer } from "@angular/platform-browser";
import { url } from "inspector";
import { PageOptions } from "../interface/pageOptions";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

export interface EXAMS {}

@Component({
    selector: "app-exams",
    templateUrl: "./exams.component.html",
    styleUrls: ["./exams.component.scss"],
})
export class ExamsComponent implements OnInit, AfterViewInit {
    laudoList = [];
    relatorioList = [];
    examesList = [];

    tiposDocumentos = [
        { label: "Laudos", value: 1 },
        { label: "Relatórios", value: 2 },
        { label: "Atestados", value: 3 },
        { label: "Exames", value: 5 },
        { label: "Receitas", value: 14 },
    ];

    documentos: any = {};
    loading: any = {};

    laudoPageOptions: PageOptions;

    show = false;
    video: any;
    empresa: any;

    dataSource = new MatTableDataSource<any>();

    displayedColumns: string[] = ["dataEnxame", "print", "download"];

    visualizar = false;
    baixar = false;
    documento: any;

    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;

    typeDocument: any = 1;

    constructor(
        private examsService: ExamsService,
        private snackService: SnackBarService,
        private fuseProgressBarComponent: FuseProgressBarService,
        private _sanitizer: DomSanitizer
    ) {
        this.laudoPageOptions = new PageOptions();
    }

    ngOnInit() {
        const user = JSON.parse(localStorage.getItem("paciente"));
        this.empresa = JSON.parse(localStorage.getItem("enterprise"));
        this.buscarLaudo();
    }

    ngAfterViewInit() {}

    async onTabChange(index: number) {
        this.typeDocument = this.tiposDocumentos[index].value;
        this.buscarLaudo();
    }

    async buscarLaudo(event?, type?) {
        const user = JSON.parse(localStorage.getItem("paciente"));

        switch (type) {
            case "short":
                this.laudoPageOptions.fieldSort = event.active;
                this.laudoPageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.laudoPageOptions.page = event.pageIndex;
                this.laudoPageOptions.sizePage = event.pageSize;
                break;

            default:
                this.laudoPageOptions.page = 0;
                this.laudoPageOptions.sizePage = 10;
                break;
        }

        this.examsService
            .buscarExams(
                user.idPaciente,
                this.typeDocument,
                this.laudoPageOptions
            )
            .then((res) => {
                this.laudoList = res.data.content;
                this.totalElements = res.data.totalElements;
                this.pagina = res.data.number;
            });
    }

    async buscarDocument(
        idDocumento: number,
        idPaciente: number,
        type?: string
    ) {
        console.log("🚀 ~ ExamsComponent ~ buscarDocument ~ type:", type);
        let document;

        if (type == "Exame" || type == "Receita") {
            await this.examsService
                .buscarRequest(idDocumento, idPaciente)
                .then((result) => {
                    document = result;
                })
                .catch((error) => {
                    this.snackService.warnMessage("Documento não localizado");
                });
        } else {
            await this.examsService
                .buscarDocument(idDocumento, idPaciente)
                .then((result) => {
                    document = result;
                })
                .catch((error) => {
                    this.snackService.warnMessage("Documento não localizado");
                });
        }

        return document;
    }

    async exibirDocumet(idDocumento: number, idPaciente: number, type: any) {
        this.fuseProgressBarComponent.show();
        let resultDocument = await this.buscarDocument(
            idDocumento,
            idPaciente,
            type
        );
        this.htmlExibicao(resultDocument);
        //this.onClickDownloadPdf(document.arquivoPDF, titulo)
    }

    htmlExibicao(document) {
        const type = "pdf";
        const tag = "embed";

        // aqui o PDF vem como link
        const pdfUrl = document.pdf; // exemplo: "https://meuservidor.com/documentos/arquivo.pdf"

        const html = `
        <html>
            <title>Documento</title>
            <body style="margin:0!important">
                <${tag} width="100%" height="100%" src="${pdfUrl}" type="application/${type}" />
            </body>
        </html>
    `;

        setTimeout(() => {
            const win = window.open("", "_blank");
            win.document.write(html);
            win.document.close();
            this.fuseProgressBarComponent.hide();
        }, 100);
    }
    async preparaDownload(idDocumento: number, idPaciente: number, type: any) {
         this.fuseProgressBarComponent.show();
        let resultDocument = await this.buscarDocument(
            idDocumento,
            idPaciente,
            type
        );
        this.onClickDownloadPdf(resultDocument);
    }

    onClickDownloadPdf(document) {
        const pdfUrl = document.pdf;
        this.downloadPdf(pdfUrl);
    }

    downloadPdf(pdfUrl: string) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "document.pdf";
        link.target = "_blank";
        link.click();
         this.fuseProgressBarComponent.hide();
    }
}
